import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { FooterRG } from '@/components/FooterRG';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';

import { AccountLink } from './AccountLink';

export const AccountFooter = () => {
    const navigation = useNavigation();
    const { t } = useTranslation(['common']);

    return (
        <>
            <SizedBox value={16} />
            <AccountLink
                children={
                    <TouchableOpacity onPress={() => navigation.navigate('Logout')}>
                        <Text
                            variant={'bodyLarge'}
                            color={ds.colorToken.text.danger}
                            letterSpacing={-0.43}
                            lineHeight={24}
                        >
                            {t('logout')}
                        </Text>
                    </TouchableOpacity>
                }
                height={56}
                justifyContent={'center'}
            />
            <FooterRG />
        </>
    );
};
